import {memo, useState, useCallback, useEffect, useRef} from 'react';

import styled from 'styled-components';

import useOnInactivity from '~/shared/hooks/useOnInactivity';
import {getLocalizationService} from '~/shared/services/localisationService';
import {A11yFeatChangeMessage} from '~/shared/types/a11y';

const IframeContainer = styled.div`
  width: 100vw;
  position: absolute;
  left: 0;
  top: 0;
  background: ${({theme}) => theme.colors.surface};
`;

const StyledIframe = styled.iframe`
  border: 0;
  background-color: transparent;
  width: 100%;
  height: 585px;
`;

const DELIVERY_TRACKER_MAP_RELOAD_AFTER_INACTIVITY_MS = 30000;

const DeliveryTracker = memo(({trackerUrl, isContrastActive}: {
  trackerUrl: string;
  isContrastActive: boolean;
}) => {
  const {currentLanguageKey} = getLocalizationService();
  const iFrameRef = useRef<HTMLIFrameElement>(null);

  const [invalidateIframeKey, setInvalidateIframeKey] = useState(0);

  const invalidateIframe = useCallback(() => setInvalidateIframeKey(key => key + 1), []);

  useOnInactivity(DELIVERY_TRACKER_MAP_RELOAD_AFTER_INACTIVITY_MS, invalidateIframe);

  const deliveryTrackerTrackerUrlByCurrentLang = trackerUrl.replace(/lang=[A-Za-z]+/, `lang=${currentLanguageKey}`);

  useEffect(() => {
    const a11yFeatChangeMessage: A11yFeatChangeMessage = {isContrastActive};
    if (iFrameRef.current) {
      iFrameRef.current.contentWindow?.postMessage(JSON.stringify(a11yFeatChangeMessage), '*');
    }
  }, [isContrastActive]);

  return (
    <IframeContainer>
      <StyledIframe ref={iFrameRef} key={invalidateIframeKey} src={deliveryTrackerTrackerUrlByCurrentLang} />
    </IframeContainer>
  );
});

export default DeliveryTracker;
